import React from 'react';
import { Card, Row, Col, Table } from 'react-bootstrap';

const TokenUsageStatistics = ({ statistics }) => {
  if (!statistics) {
    return null;
  }

  const { monthly_totals, module_breakdown, grand_totals } = statistics;

  // Get current month for highlighting
  const currentMonth = new Date().toISOString().slice(0, 7); // YYYY-MM format

  // Get current month's module data for the breakdown table
  const currentMonthModuleData = module_breakdown.map(moduleData => {
    const currentMonthData = moduleData.months.find(m => m.month === currentMonth);
    return {
      module: moduleData.module,
      ...currentMonthData
    };
  }).filter(m => m.total_tokens); // Only include modules with data for current month

  // Sort by total tokens descending
  currentMonthModuleData.sort((a, b) => b.total_tokens - a.total_tokens);

  return (
    <Card className="mb-4">
      <Card.Body>
        <Card.Title>Token Usage Statistics</Card.Title>
        
        <h5 className="mt-3 mb-3">Monthly Overview</h5>
        <Row>
          {monthly_totals.slice(0, 3).map((monthData, index) => (
            <Col md={4} key={monthData.month} className="mb-3">
              <Card 
                className={`h-100 ${monthData.month === currentMonth ? 'border-primary' : ''}`}
              >
                <Card.Body>
                  <Card.Title className="h6">{monthData.month_label}</Card.Title>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Total Tokens:</span>
                    <span className="fw-bold">{monthData.total_tokens.toLocaleString()}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Requests:</span>
                    <span className="fw-bold">{monthData.request_count.toLocaleString()}</span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {currentMonthModuleData.length > 0 && (
          <>
            <h5 className="mt-4 mb-3">Usage by Module (Current Month)</h5>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Module</th>
                  <th className="text-end">Total Tokens</th>
                  <th className="text-end">Requests</th>
                </tr>
              </thead>
              <tbody>
                {currentMonthModuleData.map((moduleData) => (
                  <tr key={moduleData.module}>
                    <td>{moduleData.module}</td>
                    <td className="text-end">{moduleData.total_tokens.toLocaleString()}</td>
                    <td className="text-end">{moduleData.request_count.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}

        {grand_totals && grand_totals.total_tokens > 0 && (
          <div className="mt-3 p-3 bg-light rounded">
            <h6 className="mb-2">Grand Totals (Last {monthly_totals.length} Months)</h6>
            <Row>
              <Col md={3}>
                <div className="d-flex justify-content-between">
                  <span>Total Tokens:</span>
                  <span className="fw-bold">{grand_totals.total_tokens.toLocaleString()}</span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex justify-content-between">
                  <span>Prompt Tokens:</span>
                  <span className="fw-bold">{grand_totals.prompt_tokens.toLocaleString()}</span>
                </div>
              </Col>
              <Col md={3}>
                <div className="d-flex justify-content-between">
                  <span>Completion Tokens:</span>
                  <span className="fw-bold">{grand_totals.completion_tokens.toLocaleString()}</span>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default TokenUsageStatistics;
